import React, { useState, useEffect, useRef } from "react";
import "./Cajeros/stylesNew2.css";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import QPM from '../../recursos/Cajero-cobro-quickpay.png';
import QP101 from '../../recursos/Cajero-Quickpay101.png';
import QP301 from '../../recursos/cajero-Quickpay301.png';
import Kiokospay from '../../recursos/Kiosko-pay.png';
import { Link } from 'react-router-dom';
import { setupScene } from '../3d/QPMINI_6_ILUMINADO';

gsap.registerPlugin(ScrollTrigger);

const Gallery = () => {
    useEffect(() => {
        gsap.set(".photo.red", { opacity: 1, scale: 1 });
        gsap.set(".photo.green", { opacity: 0, scale: 0.5 });
        gsap.set(".photo.blue", { opacity: 0, scale: 0.5 });
        gsap.set(".photo.grey", { opacity: 0, scale: 0.5 });

        ScrollTrigger.create({
            trigger: '.gallery',
            start: 'top top',
            end: 'bottom bottom',
            pin: '.right',
            scrub: true,
            onUpdate: (self) => {
                const progress = self.progress;
                const section = Math.floor(progress * 4);
                const sectionProgress = (progress * 4) % 3; // Progreso dentro de cada sección
                console.log(`Section: ${section}, Progress: ${sectionProgress}`);

                // Animaciones para cada sección
                switch (section) {
                    case 0: // Primera imagen (red)
                        gsap.to(".photo.red", {  opacity: 1 - sectionProgress, scale: 1 - sectionProgress * 0.5});
                        gsap.to(".photo.green, .photo.blue, .photo.grey", { opacity: 0, scale: 0.8 });
                        break;

                    case 1: // Segunda imagen (green)
                        gsap.to(".photo.red", { opacity: Math.max(1 - sectionProgress * 1.5, 0), scale: 1 - sectionProgress * 0.2 });
                        gsap.to(".photo.green", { opacity: Math.min(sectionProgress * 1.5, 1), scale: 0.8 + sectionProgress * 0.2 });
                        gsap.to(".photo.blue, .photo.grey", { opacity: 0, scale: 0.8 });
                        break;

                    case 2: // Tercera imagen (blue)
                        gsap.to(".photo.green", { opacity: 1 - sectionProgress, scale: 1 - sectionProgress * 0.2 });
                        gsap.to(".photo.blue", { opacity: sectionProgress, scale: 0.8 + sectionProgress * 0.2 });
                        gsap.to(".photo.grey", { opacity: 0, scale: 0.8 });
                        break;

                    case 3: // Cuarta imagen (grey)
                        gsap.to(".photo.blue", { opacity: 1 - sectionProgress, scale: 1 - sectionProgress * 0.2 });
                        gsap.to(".photo.grey", { opacity: sectionProgress, scale: 0.8 + sectionProgress * 0.2 });
                        break;
                }

            },
        });

        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, []);



    const mountRef = useRef(null);
    useEffect(() => {
        const cleanup = setupScene(mountRef, "QPMINI");
        return cleanup;
    }, []);


    return (
        <div className="min-h-screen bg-[#1a1f2b] text-white font-sans flex items-center justify-center">
            <div className="gallery">

                <div className="left">
                    <div className="detailsWrapper">

                        <div className="details" >

                            <div className="space-y-6">
                                <div>
                                    <p className="texto mb-6">QuickpayMini</p>
                                    <p className="text-sm text-gray-400 uppercase mb-2 mt-6">Medidas del producto</p>
                                    <p className="text-sm text-gray-300 leading-relaxed">
                                        Gabinete principal: 65 cm (alto) x 38 cm (ancho) x 31 cm (fondo).<br />
                                        Módulo adicional (lector, checador, etc.): dimensiones variadas desde 4 a 22 cm.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Descripcion del producto</p>
                                    <p className="text-base text-white leading-relaxed">
                                        A pocket-sized device that allows consumers to test toxic chemicals in their food. This device uses a colorimetric method to detect the presence of nitrates in meat, vegetables, and other food products.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Capacidad del producto</p>
                                    <div className="flex gap-4">
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">💵 600 billetes, acepta y recicla 6 denominaciones</button>
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">🪙 600 monedas, reciclaje de 6 denominaciones</button>

                                    </div>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Size / Package Dimensions</p>
                                    <p className="text-sm text-gray-300">3.9” x 1.3” x 0.8” / 10 x 3.4 x 2 cm</p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Color</p>
                                    <div className="flex gap-3">
                                        <span className="w-5 h-5 rounded-full bg-gray-300"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-500"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-800"></span>
                                    </div>
                                </div>
                                <button
                                    className="mt-3 rounded-2xl px-6 py-2 font-medium"
                                    style={{
                                        backgroundColor: "white",
                                        color: "black",
                                    }} >
                                    <Link
                                        to="/Producto3D/QPMINI"
                                        className="no-underline text-inherit"
                                    >
                                        Ver Modelo
                                    </Link>
                                </button>
                            </div>

                        </div>

                        <div className="details" >

                            <div className="space-y-6">
                                <div>
                                    <p className="texto mb-6">Quickpay101</p>
                                    <p className="text-sm text-gray-400 uppercase mb-2 mt-6">Medidas del producto</p>
                                    <p className="text-sm text-gray-300 leading-relaxed">
                                        Gabinete: 1,500 mm (alto) x 400 mm (ancho) x 530 mm (profundidad).<br />
                                        Área mínima de instalación: 900 mm x 850 mm.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Descripcion del producto</p>
                                    <p className="text-base text-white leading-relaxed">
                                        A pocket-sized device that allows consumers to test toxic chemicals in their food. This device uses a colorimetric method to detect the presence of nitrates in meat, vegetables, and other food products.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Capacidad del producto</p>
                                    <div className="flex gap-4">
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">💵 hasta 1,000 billetes. Recicla 2 denominaciones</button>
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">🪙 5 tubos para monedas. 2 hoppers con capacidad de 1,200 monedas cada uno</button>

                                    </div>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Size / Package Dimensions</p>
                                    <p className="text-sm text-gray-300">3.9” x 1.3” x 0.8” / 10 x 3.4 x 2 cm</p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Color</p>
                                    <div className="flex gap-3">
                                        <span className="w-5 h-5 rounded-full bg-gray-300"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-500"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-800"></span>
                                    </div>
                                </div>
                                <button
                                    className="mt-3 rounded-2xl px-6 py-2 font-medium"
                                    style={{
                                        backgroundColor: "white",
                                        color: "black",
                                    }} >
                                    <Link
                                        to="/Producto3D/KP101"
                                        className="no-underline text-inherit"
                                    >
                                        Ver Modelo
                                    </Link>
                                </button>
                            </div>

                        </div>

                        <div className="details" >
                            <div className="space-y-6">
                                <div>
                                    <p className="texto mb-6">Quickpay301</p>
                                    <p className="text-sm text-gray-400 uppercase mb-2 mt-6">Medidas del producto</p>
                                    <p className="text-sm text-gray-300 leading-relaxed">
                                        Gabinete: 1,600 mm (alto) x 550 mm (ancho) x 800 mm (profundidad).<br />
                                        Área mínima de instalación: 1,000 mm x 1,200 mm.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Descripcion del producto</p>
                                    <p className="text-base text-white leading-relaxed">
                                        A pocket-sized device that allows consumers to test toxic chemicals in their food. This device uses a colorimetric method to detect the presence of nitrates in meat, vegetables, and other food products.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Capacidad del producto</p>
                                    <div className="flex gap-4">
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">💵 Hasta 1,500 billetes + 2 dispensadores de 500 billetes cada uno</button>
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">🪙 2 hoppers con hasta 3,000 monedas en total. 6 tubos recicladores</button>

                                    </div>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Size / Package Dimensions</p>
                                    <p className="text-sm text-gray-300">3.9” x 1.3” x 0.8” / 10 x 3.4 x 2 cm</p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Color</p>
                                    <div className="flex gap-3">
                                        <span className="w-5 h-5 rounded-full bg-gray-300"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-500"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-800"></span>
                                    </div>
                                </div>
                                <button
                                    className="mt-3 rounded-2xl px-6 py-2 font-medium"
                                    style={{
                                        backgroundColor: "white",
                                        color: "black",
                                    }} >
                                    <Link
                                        to="/Producto3D/KP101"
                                        className="no-underline text-inherit"
                                    >
                                        Ver Modelo
                                    </Link>
                                </button>
                            </div>

                        </div>


                        <div className="details" >

                            <div className="space-y-6">
                                <div>
                                    <p className="texto mb-6">Kiokospay</p>
                                    <p className="text-sm text-gray-400 uppercase mb-2 mt-6">Medidas del producto</p>
                                    <p className="text-sm text-gray-300 leading-relaxed">
                                        Gabinete: 1,600 mm (alto) x 550 mm (ancho) x 800 mm (profundidad).<br />
                                        Área mínima de instalación: 1,000 mm x 1,200 mm.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Descripcion del producto</p>
                                    <p className="text-base text-white leading-relaxed">
                                        A pocket-sized device that allows consumers to test toxic chemicals in their food. This device uses a colorimetric method to detect the presence of nitrates in meat, vegetables, and other food products.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Capacidad del producto</p>
                                    <div className="flex gap-4">
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">🖥️ Terminal de cobro</button>
                                        <button className="px-4 py-1 border border-gray-600 rounded-full text-sm text-gray-300 hover:bg-gray-700">💳 Paga con cualquier tarjeta</button>

                                    </div>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Size / Package Dimensions</p>
                                    <p className="text-sm text-gray-300">3.9” x 1.3” x 0.8” / 10 x 3.4 x 2 cm</p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-400 uppercase mb-2">Color</p>
                                    <div className="flex gap-3">
                                        <span className="w-5 h-5 rounded-full bg-gray-300"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-500"></span>
                                        <span className="w-5 h-5 rounded-full bg-gray-800"></span>
                                    </div>
                                </div>
                                <button
                                    className="mt-3 rounded-2xl px-6 py-2 font-medium"
                                    style={{
                                        backgroundColor: "white",
                                        color: "black",
                                    }} >
                                    <Link
                                        to="/Producto3D/Kioskopay"
                                        className="no-underline text-inherit"
                                    >
                                        Ver Modelo
                                    </Link>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="right">
                    <div className="photos">
                        <div className="absolute right-12 top-1/2 transform -translate-y-1/2 w-[400px] h-[400px] bg-[#ffffffdd] rounded-full blur-[200px] z-0"></div>

                        <div className="photo red">
                            <div
                                ref={mountRef}
                                className='modelo3d'
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative',
                                }}
                            />
                        </div>
                        <div className="photo green">
                            <img
                                src={QP101}
                                
                                style={{
                                    width: '50%', // Ocupa el 70% del ancho de la sección
                                    height: 'auto',
                                }}
                            />
                        </div>
                        <div className="photo blue">
                            <img
                                src={QP301}
                                style={{
                                    width: '30%', // Ocupa el 70% del ancho de la sección
                                    height: 'auto',
                                }}
                            />
                        </div>

                        <div className="photo grey">
                            <img
                                src={Kiokospay}
                                style={{
                                    width: '70%', // Ocupa el 70% del ancho de la sección
                                    height: 'auto',
                                }}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gallery;
